import { Navigate, Route, Routes } from "react-router-dom";
import Frontend from "../modules/portfolio/components/Frontend/App";
import Home from "../modules/portfolio/components/Home/App";
import UIUX from "../modules/portfolio/components/UIUX/App"; 
import Middleware from "../modules/portfolio/components/Middleware/App";
import DigitalMarketing from "../modules/portfolio/components/DigitalMarketing/App";
import About from "../modules/portfolio/components/About/App";
import PortfolioDetails from "../modules/common/PortfolioDetails";
import ThoughtCloudHome from "../modules/thoughtcloud/components/Create/App";
import ThoughtCloudDashboard from "../modules/thoughtcloud/components/Dashboard/App";

const AppRoutes = () => {
    return ( 
        <Routes>
            <Route exact path="/" element={<Navigate to="/portfolio/home" />} />
            <Route path="/portfolio/home" element={<Home />} />
            <Route path="/portfolio/uiux" element={<UIUX />} />
            <Route path="/portfolio/frontend" element={<Frontend />} />
            <Route path="/portfolio/middleware" element={<Middleware />} />
            <Route path="/portfolio/digitalmarketing" element={<DigitalMarketing />} />
            <Route path="/portfolio/about" element={<About />} />
            <Route path="/portfolio/uiux/details" element={<PortfolioDetails />} />

            <Route exact path="/thoughtcloud" element={<Navigate to="/thoughtcloud/home" />} />
            <Route path="/thoughtcloud/create" element={<ThoughtCloudHome />} />
            <Route path="/thoughtcloud/home" element={<ThoughtCloudDashboard />} />
        </Routes>
    )
}

export default AppRoutes;